import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';

@Component({
    selector: 'loyaltic-confirm-receipt-upload',
    templateUrl: './confirm-receipt-upload.component.html',
    styleUrls: ['./confirm-receipt-upload.component.scss'],
    standalone: false
})
export class ConfirmReceiptUploadComponent implements OnInit {

  @ViewChild('confirmReceiptUpload', { static: false }) confirmReceiptUploadRef: any;

  userId = '';
  receiptNotApprovedData: any;
  IsUserAlreadyLoggedIn = false;

  public modalRef: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };


  constructor( private modalService: BsModalService,
    private dataService:DataServiceService,
     public translate: TranslateService,
     private router: Router,
     private authService: AuthService,
     private coreService: CoreService
     ) {
      this.userId = this.authService.getUserId();
      if (this.userId) {
        this.IsUserAlreadyLoggedIn = true;
      }
  }

  ngOnInit() {
    this.receiptNotApprovedData = this.dataService.getReceiptNotApprovedData();
  }

  onReceiptConfirm() {
    this.coreService.confirmReceiptUpload(this.receiptNotApprovedData.recptPartitionKey, this.receiptNotApprovedData.recptRowKey)
      .then((response: any) => {
        this.modalRef.hide();
        // this.gaService.emitEvent('upload_receipt', 'upload_receipt');
        // this.gaService.conversionEmitter("playWithReceipt");
        if (this.IsUserAlreadyLoggedIn) {
          // this.resetForm();
          localStorage.setItem('isWithFlow', '1');
          localStorage.setItem('playType', '1');
          this.router.navigate(['play']);
        } else {
          // this.gaService.emitEvent('login', 'uploadReceipt');
          // this.resetForm();
          const result = response.result;
          this.authService.setToken(this.receiptNotApprovedData.token, this.receiptNotApprovedData.id);
          localStorage.setItem('isWithFlow', '1');
          localStorage.setItem('playType', '1');
          this.router.navigate(['play']);
        }
      });
  }


  ngAfterViewInit() {
    this.modalRef = this.modalService.show(this.confirmReceiptUploadRef, this.popupConfig);

  }

  hideModal() {
    this.modalRef.hide();
    this.router.navigate([this.router.url])
  }
}
